import { useTranslation } from "react-i18next";
import { LogoLoader } from "@libs/zapi-ui/custom";
import { cn } from "@/zapi-frontend/shared/lib/utils";

type TPageLoaderProps = {
  className?: string;
  "data-testid"?: string;
};

export function PageLoader({ className, "data-testid": testId }: TPageLoaderProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn("flex h-full min-h-[calc(100svh-var(--app-header-height)-2rem)] w-full flex-1 items-center justify-center", className)}
      data-testid={testId}
    >
      <LogoLoader label={t("loading")} />
    </div>
  );
}
